import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Logo.scss';
import logo from '../imgs/LIVeasy_blue.png';
import logoWhite from '../imgs/LIVeasy_white.png';



function Logo() {

  return (
    <>
    <Link to="/" className='logo'>
      {/* <div>
        <h1>LIVeasy</h1>
        <p>RC: 7530355</p>
      </div> */}
  
      {/* <div className='logo-box'>  */}
        <img src={logoWhite} />
        <p>RC: 7530355</p>
      {/* </div> */}
    </Link>
      
    </>
    
  )
}

export default Logo;
